import { render, staticRenderFns } from "./produktupdateliste.vue?vue&type=template&id=09d7e306&scoped=true&"
import script from "./produktupdateliste.vue?vue&type=script&lang=js&"
export * from "./produktupdateliste.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d7e306",
  null
  
)

export default component.exports